###
# Provides modal functionality. It should be used to show and hide modals. It
# will add an overlay to the background when a modal is visible, and prevents
# the body from scrolling when a modal is open.
#
# It should be set as an attribute on the ``<body>`` element.
#
# Example:
#
# (partial)
#
# ```html
# <div>
#   <div class="rj-modal" id="foo">
#     <h1>Hello World</h1>
#     <button ng-click="hideModal()">Close</button>
#   </div>
# </div>
# ```
#
# (controller)
#
# ```coffeescript
# directive "someDirective", [
#   () ->
#     require: "^rjmUi"
#     # ...
#     link: (scope, element, attributes, rjmUi) ->
#
#       scope.showModal = () ->
#         rjmUi.showModal("foo")
#
#       scope.hideModal = () ->
#         rjmUi.hideModal("foo")
#
# ]
# ```
#
# NOTE: modals are not implemented for CBI.
###

angular.module('rjmNg.common.directives').directive "rjmUi", [
  "app"
  "$document"
  "$templateCache"
  (
    app
    $document
    $templateCache
  ) ->
    restrict: "A"
    controller: [
      "$scope"
      "$rootScope"
      (
        $scope
        $rootScope
      ) ->

        $scope.modalStack = []

        $scope.updateOverlayClasses = () ->
          openModals = $(".rj-modal.open")
          if openModals.length and $scope.showOverlayClasses?
            $scope.showOverlayClasses()
          else if $scope.hide?
            $scope.hide()

          [otherModals..., topModal] = $scope.modalStack

          for modal in otherModals
            modal.modal.addClass("no-scroll")

          topModal?.modal.removeClass("no-scroll")

        evaluateSelector = (selector) ->
          if selector instanceof jQuery
            return selector
          else
            # Assume the selector is an id
            return $("##{selector}")

        @showModal = (selector, overlayClasses=null) ->
          modal = evaluateSelector(selector).filter(".rj-modal").first()
          if modal.length and not modal.is(".open")
            modal.addClass("open")
            modalObj =
              modal: modal

            if overlayClasses?
              modalObj.overlay = $("<div></div>").addClass(overlayClasses).insertBefore(modal)

            $scope.modalStack.push modalObj
            $scope.updateOverlayClasses()

        @hideModal = (selector) ->
          modal = evaluateSelector(selector).filter(".rj-modal").first()
          if modal.length and modal.is(".open")
            modal.removeClass("open")

            for _modal in $scope.modalStack when _modal.modal.is(modal)
              if _modal.overlay?
                _modal.overlay.remove()

            $scope.modalStack = $scope.modalStack.filter (_modal) -> not _modal.modal.is(modal)
            $scope.updateOverlayClasses()

        uiBlockedBy = {}

        $scope.updateBlockedUi = () ->
          blocked = _.some uiBlockedBy, (val) -> val
          if $scope.setBlockedUi?
            $scope.setBlockedUi(blocked)

        $scope.clearBlockedUi = () ->
          uiBlockedBy = {}
          $scope.setBlockedUi(false)

        @loadingUi = (key, isLoading, message) ->
          @blockUi(key, isLoading)
          $scope.setLoadingLogo(message)

        @blockUi = (key, blocked, isLoadingLogo=false) ->
          if blocked
            uiBlockedBy[key] = true
          else
            delete uiBlockedBy[key]

          $scope.updateBlockedUi()

        $rootScope.$on('$locationChangeStart', (next, current) -> 
          $scope.clearBlockedUi()
        )

        @

    ]
    link: (scope, elm, attrs) ->

      unless $(".rj-modal-overlay").length
        $("body").append("<div class='rj-modal-overlay'></div>")

      unless $(".rj-blocked-overlay").length
        $("body").append("<div class='rj-blocked-overlay'></div>")

      scope.setLoadingLogo = (message) ->
        logo = $templateCache.get "assets/logos/loading.svg"
        $logo = angular.element(logo)[0]
        logoDiv = $document[0].createElement('div')
        logoDiv.classList.add('rj-dodeca-loader', 'rj-dodeca-loader--overlay')
        logoDiv.appendChild $logo

        if message && message.length
          messageDiv = $document[0].createElement 'h2'
          messageDiv.classList.add('rj-dodeca-loader__message')
          messageDiv.innerHTML = message
          logoDiv.appendChild messageDiv

        $(".rj-blocked-overlay").html logoDiv


      scope.showOverlayClasses = () ->
        $("body").addClass("modal-open")
        return

      scope.hide = () ->
        $("body").removeClass("modal-open")
        $(".rj-modal.open").removeClass("open")

        for modal in scope.modalStack when modal.overlay?
          modal.overlay.remove()

        scope.modalStack = []

      scope.setBlockedUi = (show) ->
        if show
          $("body").addClass("blocked")
        else
          $("body").removeClass("blocked")

]
